export var PATHS;
(function (PATHS) {
    PATHS["LOGIN"] = "/";
    PATHS["HOME"] = "/dashboard";
    PATHS["ADMIN"] = "/admin";
    PATHS["ADMIN_HOME"] = "dashboard";
    PATHS["HOME_UNITS"] = "units";
    PATHS["HOME_AMENITIES"] = "amenities";
    PATHS["ADMIN_SCAN_REQUESTS"] = "scan-requests";
    PATHS["ADMIN_USERS"] = "users";
    PATHS["ADMIN_COMMUNITIES"] = "communities";
    PATHS["ADMIN_ORGANIZATIONS"] = "organizations";
    PATHS["ADMIN_MAGIC_BUTTONS"] = "magic-buttons";
    PATHS["ADMIN_BETA_FEATURES"] = "beta-features";
    PATHS["ADMIN_AI_DISCOVERABILITY"] = "ai-discoverability";
    PATHS["ERROR"] = "/error";
    PATHS["SPACES"] = "/spaces";
    PATHS["SCAN_REQUESTS"] = "scan-requests";
    PATHS["SCAN_REQUESTS_ADMIN_REQUESTS"] = "requests";
    PATHS["SCAN_REQUESTS_ADMIN_COMPLETED"] = "completed";
    PATHS["SCAN_REQUESTS_ADD_NEW_REQUEST"] = "add-new-request";
    PATHS["SCAN_REQUESTS_UPCOMING_SHOOTS"] = "upcoming-shoots";
    PATHS["SCAN_REQUESTS_PAST_SHOOTS"] = "past-shoots";
    PATHS["SCAN_REQUESTS_UNSCHEDULED_REQUESTS"] = "unscheduled-requests";
    PATHS["UNIT"] = "/unit";
    PATHS["AMENITY"] = "/amenity";
    PATHS["ANALYTICS"] = "/analytics";
    PATHS["VIRTUAL_TOURS_ANALYTICS"] = "virtual-tours";
    PATHS["SELF_GUIDED_TOURS_ANALYTICS"] = "self-guided-tours";
    PATHS["ENGAGEMENT_ANALYTICS"] = "engagement";
    PATHS["CONVERSION_ANALYTICS"] = "conversion";
    PATHS["CONTENT_CREATION_ANALYTICS"] = "content-creation";
    PATHS["USERS"] = "/users";
    PATHS["USERS_USERS"] = "users";
    PATHS["USERS_PERFORMANCE"] = "performance";
    PATHS["USERS_USER_REQUESTS"] = "user-request";
    PATHS["SGT"] = "/sgt";
    PATHS["SGT_AVAILABLE_UNITS"] = "available-units";
    PATHS["SGT_UNAVAILABLE_UNITS"] = "unavailable-units";
    PATHS["SGT_AMENITIES"] = "amenities";
    PATHS["SGT_SCHEDULES"] = "schedules";
    PATHS["SGT_ACCESS_DEVICES"] = "access-devices";
    PATHS["TERMS_CONDITIONS_AGREEMENT"] = "/terms-conditions-agreement";
    PATHS["FORGOT_PASSWORD"] = "/forgot-password";
    PATHS["RESET_PASSWORD"] = "/reset-password";
    PATHS["LOGIN_ERROR"] = "/login-error";
    PATHS["SSO_LOGIN"] = "/sso-login";
    PATHS["REQUEST_ACCESS"] = "/request-access";
    PATHS["REQUEST_ACCESS_CONFIRMATION"] = "/request-access/confirmation";
    PATHS["USER_SETTINGS"] = "/user-settings";
    PATHS["USER_SETTINGS_PROFILE"] = "profile";
    PATHS["USER_SETTINGS_EMAIL_NOTIFICATIONS"] = "emails";
    PATHS["USER_SETTINGS_GMBANDWIDGETS"] = "gmb-and-widgets";
    PATHS["ACCOUNT_HEALTH"] = "/account-health";
    PATHS["PROSPECT_INTELLIGENCE"] = "/pi";
    PATHS["PROSPECT_INTELLIGENCE_ALL"] = "/pi/all-prospects";
    PATHS["PROSPECT_INTELLIGENCE_DETAILS_SUMMARY"] = "summary";
    PATHS["PROSPECT_INTELLIGENCE_DETAILS_ACTIVITY"] = "activity";
    PATHS["COMMUNITIES"] = "/communities";
    PATHS["COMMUNITY_SETTINGS_DETAILS"] = "details";
    PATHS["COMMUNITY_SETTINGS_AUTOSCAN"] = "auto-scan";
    PATHS["COMMUNITY_SETTINGS_WIDGETS"] = "widgets";
    PATHS["COMMUNITY_SETTINGS_SGT"] = "sgt-settings";
    PATHS["COMMUNITY_SETTINGS_DX"] = "dx-settings";
    PATHS["COMMUNITY_SETTINGS_CASA"] = "casa-settings";
    PATHS["COMMUNITY_SETTINGS_REGIONAL_LEASING"] = "regional-leasing";
    PATHS["DEDUPE_UNITS"] = "dedupe-units";
    PATHS["CONTENT_SERVICES"] = "content-services";
    PATHS["CONTENT_SERVICES_PENDING_REQUESTS"] = "pending-requests";
    PATHS["CONTENT_SERVICES_SCANNERS"] = "scanners";
})(PATHS || (PATHS = {}));
